class PdpStickyBar extends HTMLElement {
  connectedCallback() {
    this.initialize();
  }

  disconnectedCallback() {
    this.cleanup();
  }

  cleanup() {
    this.observer?.disconnect();
    this.stickyBarResizeObserver?.disconnect();
    this.chatButtonResizeObserver?.disconnect();
    window.removeEventListener("gorgias-widget-loaded", this.observeChatButton);
    this.setStickyBarVisibility?.(false);
  }

  initialize() {
    this.cleanup();
    const stickyBar = this;
    const backToTopButton = document.getElementById("js-back-to-top");
    const primaryAddToCartButton = document.querySelector(
      ".product__info-container .product-form__submit:not(.product-form__submit--mobile)",
    );

    if (!primaryAddToCartButton || this.getAttribute("data-enable-exclusive") === "true") return;

    const stickyBarGap = 16;
    const minimumChatButtonGap = 4;

    /**
     * Show the sticky bar only after the primary Add to Cart button has
     * passed above the viewport. Keep it hidden while the button is visible
     * or is still further down the page.
     */
    const positionFloatingControls = () => {
      const stickyBarHeight = stickyBar.offsetHeight;
      const chatButton = document.getElementById("chat-button");
      let chatButtonGap = stickyBarGap;

      document.body.style.setProperty("--pdp-sticky-bar-height", `${stickyBarHeight}px`);

      if (backToTopButton) {
        backToTopButton.style.bottom = `${stickyBarHeight + stickyBarGap}px`;

        if (chatButton?.offsetHeight && backToTopButton.offsetHeight) {
          const heightDifference = chatButton.offsetHeight - backToTopButton.offsetHeight;
          chatButtonGap = Math.max(minimumChatButtonGap, stickyBarGap - heightDifference / 2);
        }
      }

      document.body.style.setProperty("--pdp-chat-button-gap", `${chatButtonGap}px`);
    };

    const setStickyBarVisibility = (isVisible) => {
      stickyBar.style.display = isVisible ? "block" : "none";
      stickyBar.classList.toggle("js--animate-sticky-bar", isVisible);
      document.body.classList.toggle("pdp-sticky-bar-visible", isVisible);

      if (backToTopButton) {
        backToTopButton.style.opacity = isVisible ? "1" : "0";
        backToTopButton.style.visibility = isVisible ? "visible" : "hidden";
        backToTopButton.style.bottom = "";
      }

      if (isVisible) {
        positionFloatingControls();
      } else {
        document.body.style.removeProperty("--pdp-sticky-bar-height");
        document.body.style.removeProperty("--pdp-chat-button-gap");
      }
    };

    if (typeof ResizeObserver === "function") {
      this.stickyBarResizeObserver = new ResizeObserver(() => {
        if (stickyBar.style.display !== "none") positionFloatingControls();
      });

      this.stickyBarResizeObserver.observe(stickyBar);

      let observedChatButton;

      const observeChatButton = () => {
        const chatButton = document.getElementById("chat-button");

        if (!chatButton || chatButton === observedChatButton) return;

        this.chatButtonResizeObserver?.disconnect();
        this.chatButtonResizeObserver = new ResizeObserver(() => {
          if (stickyBar.style.display !== "none") positionFloatingControls();
        });
        this.chatButtonResizeObserver.observe(chatButton);
        observedChatButton = chatButton;

        if (stickyBar.style.display !== "none") positionFloatingControls();
      };

      observeChatButton();
      this.observeChatButton = observeChatButton;
      window.addEventListener("gorgias-widget-loaded", this.observeChatButton);
    }

    this.observer = new IntersectionObserver(
      ([entry]) => {
        const viewportTop = entry.rootBounds?.top ?? 0;
        const hasScrolledPastButton = !entry.isIntersecting && entry.boundingClientRect.bottom <= viewportTop;

        setStickyBarVisibility(hasScrolledPastButton);
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0,
      },
    );

    this.setStickyBarVisibility = setStickyBarVisibility;
    setStickyBarVisibility(false);
    this.observer.observe(primaryAddToCartButton);
  }
}

customElements.define("pdp-sticky-bar", PdpStickyBar);
